<ambita-currency>
  <span>{ content }</span>

  <script>
    import { init } from './currencyController';

    init(this);
  </script>
</ambita-currency>
